import TumengEditor from './src/index.vue'

TumengEditor.install = function(Vue) {
  Vue.component(TumengEditor.name, TumengEditor)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengEditor)
}

export default TumengEditor
